"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationCurrentChannelsEnum = exports.NotificationChannelsEnum = exports.NotificationTypesEnum = void 0;
var NotificationTypesEnum;
(function (NotificationTypesEnum) {
    NotificationTypesEnum["TariffUpdate"] = "tariff.update";
    NotificationTypesEnum["BalanceLimit"] = "balance.limit";
    NotificationTypesEnum["BalanceAccrual"] = "balance.accrual";
    NotificationTypesEnum["BalanceDaily"] = "balance.daily";
    NotificationTypesEnum["PaymentsFailed"] = "payments.failed";
    NotificationTypesEnum["AuthRegistration"] = "auth.registration";
    NotificationTypesEnum["AuthRecover"] = "auth.recover";
    NotificationTypesEnum["PatternApproved"] = "pattern.approved";
    NotificationTypesEnum["PatternRejected"] = "pattern.rejected";
    NotificationTypesEnum["SendernameApproved"] = "sendername.approved";
    NotificationTypesEnum["SendernameRejected"] = "sendername.rejected";
    NotificationTypesEnum["SubscriptionEnabled"] = "subscription.enabled";
    NotificationTypesEnum["SubscriptionRenewFailed"] = "subscription.renew.failed";
    NotificationTypesEnum["ApisenderInstanceCreated"] = "apisender.instance.created";
    NotificationTypesEnum["ApisenderInstanceConnected"] = "apisender.instance.connected";
    NotificationTypesEnum["ApisenderInstanceDisconnected"] = "apisender.instance.disconnected";
    NotificationTypesEnum["SendingsBulkCreated"] = "sendings.bulk.created";
    NotificationTypesEnum["SendingsBulkPaused"] = "sendings.bulk.paused";
    NotificationTypesEnum["SendingsBulkResumed"] = "sendings.bulk.resumed";
    // SendingsBulkCompleted = 'sendings.bulk.completed',
    // SendingsBulkProcessing = 'sendings.bulk.processing',
    // SendingsBulkReady = 'sendings.bulk.ready',
    // SendingsBulkSending = 'sendings.bulk.sending',
    // SendingsBulkStopped = 'sendings.bulk.stopped',
    NotificationTypesEnum["SystemPlatformIssues"] = "system.platform.issues";
    NotificationTypesEnum["SystemRouteIssues"] = "system.route.issues";
})(NotificationTypesEnum || (exports.NotificationTypesEnum = NotificationTypesEnum = {}));
/**
 * @deprecated Используйте NotificationCurrentChannelsEnum
 */
var NotificationChannelsEnum;
(function (NotificationChannelsEnum) {
    // Current allowed for settings types
    NotificationChannelsEnum["email"] = "email";
    NotificationChannelsEnum["sms"] = "sms";
    NotificationChannelsEnum["web"] = "web";
    NotificationChannelsEnum["push"] = "push";
    NotificationChannelsEnum["tgBot"] = "tgBot";
    // Test notification channel
    NotificationChannelsEnum["test"] = "test";
    // All old types
    NotificationChannelsEnum["smsping"] = "smsping";
    NotificationChannelsEnum["mms"] = "mms";
    NotificationChannelsEnum["viber"] = "viber";
    NotificationChannelsEnum["voice"] = "voice";
    NotificationChannelsEnum["whatsapp"] = "whatsapp";
    NotificationChannelsEnum["vk"] = "vk";
    NotificationChannelsEnum["ok"] = "ok";
    NotificationChannelsEnum["telegram"] = "telegram";
    NotificationChannelsEnum["facebook"] = "facebook";
    NotificationChannelsEnum["instagram"] = "instagram";
    NotificationChannelsEnum["whatsappchat"] = "whatsappchat";
    NotificationChannelsEnum["viberchat"] = "viberchat";
    NotificationChannelsEnum["vkchat"] = "vkchat";
    NotificationChannelsEnum["telegramchat"] = "telegramchat";
    NotificationChannelsEnum["facebookchat"] = "facebookchat";
    NotificationChannelsEnum["flashcall"] = "flashcall";
})(NotificationChannelsEnum || (exports.NotificationChannelsEnum = NotificationChannelsEnum = {}));
var NotificationCurrentChannelsEnum;
(function (NotificationCurrentChannelsEnum) {
    // Current allowed for settings types
    NotificationCurrentChannelsEnum["email"] = "email";
    NotificationCurrentChannelsEnum["sms"] = "sms";
    NotificationCurrentChannelsEnum["web"] = "web";
    NotificationCurrentChannelsEnum["push"] = "push";
    NotificationCurrentChannelsEnum["tgBot"] = "tgBot";
})(NotificationCurrentChannelsEnum || (exports.NotificationCurrentChannelsEnum = NotificationCurrentChannelsEnum = {}));
//# sourceMappingURL=notifications.enum.js.map